import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { SharedModule } from './app/shared/shared.module';
import { environment } from './environments/environment';

if (environment.production) {
	enableProdMode();
}

console.debug(`Frontend build type: ${environment.buildType}`);

platformBrowserDynamic()
	.bootstrapModule(SharedModule)
	.then((ref) => {
		// Ensure Angular destroys itself on hot reloads.
		// Needed  for managing the lifecycle of Angular when it's used  in React.
		if (window['ngRef']) {
			window['ngRef'].destroy();
		}
		window['ngRef'] = ref;
	})
	.catch((err) => {
		console.log('failed to bootstrap: ' + err);
	});
